/* Common JS for all pages.  Run at the end of the page, so could be deferred!  (hence the extra tests on domready) */
/* global gsap */

// if (document.readyState === 'loading') {
//     document.addEventListener('DOMContentLoaded', pageJS);
// } else {
//     main();
// }

main();

function main() {

    // Activate animation on scroll
    let animate = document.getElementsByClassName('animation');
    let arrayLength = animate.length;
    for (let i = 0; i < arrayLength; i++) {
        function makeActive(entries) {
            entries.map((entry) => {
                if (entry.isIntersecting) {
                    animate[i].classList.add('animate')
                }
            });
        }
        const observer = new IntersectionObserver(makeActive);
        observer.observe(animate[i]);
    }
}

